<template>

  <div class="d-flex flex-column flex-grow-1">

    <header class="topbar">

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" to="/">W3 Website Builder</router-link>

        <ul class="navbar-nav" v-if="page.id">
            <li class="nav-item">
              <router-link class="nav-link" :to="'/project/'+page.project_id">{{ page.project.name }}</router-link>
            </li>
            <li class="nav-item dropdown" @click.stop>
              <span class="nav-link dropdown-toggle" @click="togglePageDropdown">{{ page.name }}</span>
              <div class="dropdown-menu" :class="{show:pageDropdownOpened}">
                <router-link v-for="projectPage in page.project.pages" :key="projectPage.id" class="dropdown-item" :to="'/project/'+page.project_id+'/'+projectPage.id">{{projectPage.name}}</router-link>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" @click.prevent="newPage">New page</a>
              </div>
            </li>
        </ul>

        <div class="btn-group btn-group-sm btn-group-toggle select-device ml-3" data-toggle="buttons">
          <label class="btn btn-secondary" :class="{active:previewDevice=='desktop'}">
            <input type="radio" v-model="previewDevice" value="desktop" autocomplete="off"> 
            <svg class="icosvg" viewBox="0 0 24 24">
            <path fill="currentColor" d="M21,14H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16A2,2 0 0,0 3,18H10L8,21V22H16V21L14,18H21A2,2 0 0,0 23,16V4C23,2.89 22.1,2 21,2Z" />
        </svg>
            <!-- Desktop -->
          </label>
          <label class="btn btn-secondary" :class="{active:previewDevice=='mobile'}">
            <input type="radio" v-model="previewDevice" value="mobile" autocomplete="off"> 
            <svg class="icosvg" viewBox="0 0 24 24">
            <path fill="currentColor" d="M17.25,18H6.75V4H17.25M14,21H10V20H14M16,1H8A3,3 0 0,0 5,4V20A3,3 0 0,0 8,23H16A3,3 0 0,0 19,20V4A3,3 0 0,0 16,1Z" />
        </svg>
            <!-- Mobile -->
          </label>
        </div>

        <button class="ml-3 btn btn-primary btn-sm" v-if="edited" @click="saveAllBlocks">Save</button>


        <ul class="ml-3 navbar-nav" v-if="page.id">
            <li class="nav-item dropdown" @click.stop>
              <span class="nav-link dropdown-toggle" @click="togglePublishDropdown">Publish</span>
              <div class="dropdown-menu" :class="{show:publishDropdownOpened}">
                <a target="_blank" :href="'http://'+tempurl" class="dropdown-item">{{ tempurl }}</a>
                <div class="dropdown-divider"></div>
                <span class="dropdown-item disabled soon">Custom domain</span>
                <span class="dropdown-item disabled soon">Export HTML+CSS</span>
              </div>
            </li>
        </ul>


      </nav>
    </header>


    <div class="flex-fill d-flex">
      <aside class="aside-left">
          <ul class="block-categories">
            <li v-for="category in blockCategories">
              <span>{{ category.name }}</span>
              <ul v-if="category.blocks" class="category-blocks">
                <li v-for="block in category.blocks" @mousedown="mouseDownComponent($event,block)">
                  <img v-if="block.image" :src="block.image">
                  <p v-else>{{ block.name }}</p>
                </li>
              </ul>
            </li>
          </ul>
      </aside>

      <main>
        <div class="virtualPreview">
          <component :is="previewComponent"></component>
        </div>

        <div class="browser-wrapper">
          <div class="browser" :class="previewDevice">
            <div v-if="blocks.length==0" class="browser-empty">Drag blocks from the left menu</div>
            <div class="browser-header">
              <div class="top-bar">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="tab"></div>
              </div>
              <div class="field"></div>
            </div>
            <div class="browser-window">
              <iframe class="preview" src="/iframe.html"></iframe>
            </div>
            <div class="browser-footer"></div>
          </div>
        </div>
      </main>

      <aside class="aside-right">


        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link" :class="{active:tabAsideRight=='page'}" href="#" @click.prevent="toggleTabAsideRight('page')">Page</a>
          </li>
          
          <li v-show="blocks.length>0" class="nav-item dropdown" @click.stop>
            <span class="nav-link dropdown-toggle" :class="{active:tabAsideRight=='block'}" @click="toggleBlockDropdown">Block</span>
            <div class="dropdown-menu" :class="{show:blockDropdownOpened}">
              <a v-for="block in orderedBlocks" :key="block.uid" class="dropdown-item" :class="{active:selectedComponent==block.uid}" href="#" @click.prevent="editComponent(block)">
                {{block.order}} {{ block.id }} {{ block.name }} 
              </a>
            </div>
          </li>
          </ul>
          <div v-if="page.id" class="tab-content" v-show="tabAsideRight=='page'">

            <!-- text input with hint -->
            <div class="form-group">
              <label>Title</label>
              <input v-model="page.name" type="text" class="form-control">
            </div>
            <div class="form-group">
              <label>Slug</label>
              <input v-model="page.slug" type="text" class="form-control">
            </div>
            <div class="form-group">
              <label>SEO Description</label>
              <textarea v-model="page.description" class="form-control"></textarea>
            </div>
            <div class="form-group">
              <label>SEO Image</label>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" @change="onFileChange($event,page,'image')">
                  <label class="custom-file-label">Upload</label>
                </div>
                <div v-if="page.image" class="d-flex">
                  <img :src="page.image" class="img-thumbnail">
                  <button class="close p-2" @click="page.image=''"><span>&times;</span></button>
                </div>
            </div>

            <button @click="savePage" class="btn btn-primary">Save</button>



          </div>
          <div class="tab-content" v-show="tabAsideRight=='block'">
            <component :is="asideComponent"></component>
            <div v-if="selectedComponent" class="modal-footer">
              <button class="btn btn-danger" @click="removeBlock(selectedComponent)" title="Remover bloco">
                <svg class="icosvg" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                </svg>
              </button>
            </div>
          </div>

      </aside>

    </div>
  </div>


</template>


<style scoped>
/* .select-device svg { width:20px; height:20px; } */


.topbar .navbar-nav li.nav-item:not(:last-child):after { content: '/'; color: rgba(0,0,0,.5);}
.topbar .navbar-nav a.nav-link { display:inline-block; }
.topbar .navbar-nav .dropdown-toggle { cursor:pointer; }

.soon { position:relative; opacity: .4; }
.soon:after {
    content:"soon";
    position: absolute;
    top:50%; 
    right:0;
    padding:2px 5px;
    background:#333;
    color:#fff;
    font-weight: bold;
    font-size:.8em;
    transform: translate(0,-50%) rotate(-20deg);
}

.aside-left {flex-basis:200px; background:#f2f2f2; position: relative; z-index: 3;}

.aside-left .block-categories { list-style:none; overflow:auto; margin:0; padding:0; }
.aside-left .block-categories > li { padding:2px 5px; }
.aside-left .block-categories > li span { display: block; padding:5px; background-color:#fff; border:1px solid rgba(0,0,0,.2); user-select: none; }

.aside-left .category-blocks { overflow:auto;list-style:none; display:none; position:absolute; padding:5px; top:0; bottom:0; left:100%; width:300px; background-color:#eee; }
.aside-left .category-blocks li { cursor:pointer; margin-bottom:5px; padding:5px; background-color:#fff; border:1px solid rgba(0,0,0,.2); }
.aside-left .category-blocks li img { max-width:100%; height: auto; max-height: 100px; display:block; margin:0 auto; }
.aside-left .category-blocks li p { padding:10px 5px ; }

.aside-left .block-categories > li:hover ul { display: block; }



main { flex-grow: 1; }
.browser-wrapper { max-width: 900px; margin:0 auto; height:100%; }
.browser {  transform-origin:top; display: flex; flex-direction: column; height: 100%; position: relative; }
.browser.desktop {
  transform: scale(0.7);
  height:142.85%;
  min-width: 1280px;
  transform-origin: 0 0;
}
.browser.mobile { max-width:360px; margin-left:auto; margin-right:auto; }
.browser-header{ flex-shrink: 0;}
.browser .top-bar { height: 20px; background: #cccccc; border-radius: 3px 3px 0 0; text-align: left; display: block; }
.browser .top-bar .circle { display: inline-block; height: 8px; width: 8px; border-radius: 100%; background: #999999; }
.browser .top-bar .circle:first-child { margin-left: 7px; }
.browser .top-bar .tab { box-sizing: border-box; display: inline-block; border-radius: 6px 6px 0 0; height: 14px; width: 96px; margin-left: 8px; transform: translateY(6px); border-bottom: 14px solid #e6e6e6; border-left: 7px solid transparent; border-right: 7px solid transparent; }
.browser .field { height: 18px; background: #e6e6e6; }
.browser-window { flex-grow: 1; border-left:1px solid #ccc; border-right:1px solid #ccc;}
.preview { height:100%; width:100%; border:none; display: block; min-height: 300px;  }
.browser-footer{ border-bottom:1px solid #ccc;}

.browser-empty{
  position: absolute;
  left:50%;
  top:50%;
  transform:translate(-50%,-50%);
  padding:10px;
  background:#999;
  color:#fff;
  cursor:w-resize;
  text-align: center;
  font-size: 1.5em;

}

.virtualPreview { display: none; }

.aside-right {flex-basis:300px; overflow:auto; }
.aside-right .dropdown-toggle { cursor:pointer; }

.aside-right .tab-content { background-color:#f1f1f1; padding:10px; border:1px solid #dee2e6; border-top-color:#f1f1f1;}
.aside-right .nav-tabs .nav-link.active { background:#f1f1f1; border-color:#dee2e6 #dee2e6 #f1f1f1;}


</style>


<script>

import componentFunctions from '../mixin.components.js'
import axios from 'axios';
import Vue from 'vue'
import gHeader from '../components/gHeader.vue'

export default window.vmPage = {
  name: 'page',
  // prop:['id'],
  mixins:[componentFunctions],
  components:{'g-header':gHeader},
  props:['id','page_id'],
  data() {
    return {
      tabAsideRight:'page',
      pageDropdownOpened:false,
      blockDropdownOpened:false,
      publishDropdownOpened:false,
      previewDevice:'desktop',
      edited:false,
      page:{ },
      blocks:[],
      component:'',
      asideComponent:null,
      previewComponent:null,
      selectedComponent:'',
      blockCategories:[],
      block:{},
      iframeDom:null,
    }
  },
  computed:{
    tempurl(){
      if(!this.page.id) return ''
      return this.page.project.slug+'.w3.scaalar.com/'+this.page.slug.replace(/\/$/,'')
    },
    orderedBlocks(){
      return this.blocks.sort((a,b)=>{
        if (a.order==b.order) return a.id>b.id?1:-1;
        return a.order>b.order?1:-1;
      })
    }
  },
  methods:{
    newPage(){
      axios({
        method: 'post',
        url: '/api/pages',
        data: {
          name:'Nova página',
          project_id:this.page.project_id,
        }
      }).then((res)=>{
        this.$router.push('/project/'+this.page.project_id+'/'+res.data.id);
      });
    },
    togglePageDropdown(){
      this.pageDropdownOpened = !this.pageDropdownOpened;
    },
    toggleBlockDropdown(){
      this.blockDropdownOpened = !this.blockDropdownOpened;
    },
    togglePublishDropdown(){
      this.publishDropdownOpened = !this.publishDropdownOpened;
    },
    mouseDownComponent(e,block){
      e.preventDefault();
      window.frameBus.handler = block;

    },

    getPage(){
      axios({
        url: '/api/page/'+this.page_id,
      }).then((res) => {
        this.page = res.data;
      });

    },

    getPageBlocks(){
      axios({
        url: '/api/page/'+this.page_id+'/blocks',
      }).then((res) => {
        this.blocks = res.data;
        this.loadPreview();
      });
    },

    loadPreview(){
      if(!this.iframeDom) return;
      if(this.blocks.length==0) return;
      for(var i in this.orderedBlocks){
        this.iframeDom.updateBlock(this.orderedBlocks[i].uid,this.orderedBlocks[i].output_html,this.orderedBlocks[i].output_css,this.orderedBlocks[i].output_js);
      }

    },

    getComponents(){

      axios({
        url: '/api/block-categories/blocks',
      }).then((res) => {
        this.blockCategories = res.data
      });

    },

    insertComponent:function(block,position){

      if(block) {
        var uid = 'block'+ (new Date().getTime());

        //copy object without object reference //FIXME converting to json is ugly
        var newBlock = clone(block);

        newBlock.uid = uid;
        newBlock.block_id = newBlock.id;

        if(position===null) position = count(this.blocks);
        newBlock.order = position;
        this.blocks.push(newBlock);
        this.selectedComponent = uid;
        this.toggleTabAsideRight('block');
        this.createComponent(newBlock,position);
      };
    },
    editComponent:function(block){
      this.selectedComponent = block.uid;
      this.toggleTabAsideRight('block');
      this.component = block.name;
      this.blockDropdownOpened = false; 
      this.createComponent(block);
    },

    createComponent:function(obj,position){

      Vue.component('component1-aside', {
        name:'component1-aside',
        template:obj.aside,
        data:() => obj.data,
        mixins: [componentFunctions]
      })

      Vue.component('component1-preview', {
        name:'component1-preview',
        template:obj.template,
        data:() => obj.data,
        watch:{
          '$data':{
            handler:(data,oldVal)=>{
              this.updatePreview(obj.uid,data,obj.css,obj.js,position);
              this.edited = true;
            },
            deep: true,
            //immediate: true,
          }
        }
      });

      //immediate paint to register block ordering (this.updateOrdering)
      this.updatePreview(obj.uid,obj.data,obj.css,obj.js,position);

      this.asideComponent = 'component1-aside';
      this.previewComponent = 'component1-preview';
    },

    updatePreview(uid,data,css,js,position){
      this.$nextTick(()=>{
        var html = document.querySelector('.virtualPreview').innerHTML;

        //replace variables in css
        var i;
        for (i in data){
          var regEx = new RegExp('var\\(--'+i+'\\)','g');
          css = css.replace(regEx,data[i])
        } 
        
        //remove null properties
        css = css.replace(/background-image:\s?url\((null)?\);?/g,'')

        css = this.mutateCss('.block-'+uid,css);

        this.updateOutputBlock(uid,html,css,js);
        this.iframeDom.updateBlock(uid,html,css,js,position);

      });
    },
    mutateCss(prefix,css){
      css = css.replace(/(^|,|}| )([ \t]*)([.#a-z][^{}]*?\s*){/gm,'$1$2'+prefix+' $3 {');
      //css = css.replace(/,(\n)?([ \t]*)([^\n{,]+)({|,)/gm,',$1$2'+prefix+' $3$4');
      return css; 
      //return css.replace(/(^|,|}| )([ \t]*)([.#a-z][^{}]*?\s*)(,|{)/gm,'$1$2'+prefix+' $3$4');
      //return css.replace(/^(\s*)([^@][^\n]*[{,]) *$/gm,'$1'+prefix+' $2');
    },
    updateOutputBlock(uid,html,css,js){
      var i;
      for(i in this.blocks){
        if(this.blocks[i].uid == uid){
          this.blocks[i].output_html = html;
          this.blocks[i].output_css = css;
          this.blocks[i].output_js = js;
          break;
        }
      }
    },
    savePage(e){
      axios({
        method: 'post',
        url: '/api/page/'+this.page_id,
        data: {
          name:this.page.name,
          slug:this.page.slug,
          description:this.page.description,
          image:this.page.image,
        }
      }).then(()=>{
        var buttn = e.target
        var original = buttn.innerText;
        buttn.innerText= "Ok";
        setTimeout(()=>{
          buttn.innerText = original;
        },1000);
        this.edited = false;
      });

    },
    saveAllBlocks(){
      //save list of blocks
      var data = this.orderedBlocks;


      axios({
        method: 'post',
        url: '/api/page/'+this.page_id+'/blocks',
        data: data
      }).then(()=>{
        this.edited = false;
      });

    },
    removeBlock(uid){
      var obj = this.blocks.find(block => block.uid==uid);
      var index = this.blocks.indexOf(obj);
      this.blocks.splice(index, 1);
      this.iframeDom.removeBlock(uid);
      this.selectedComponent = '';
      this.toggleTabAsideRight('page');
    },
    toggleTabAsideRight(tab){
      //if(this.selectedComponent) this.selectedComponent = '';
      this.tabAsideRight = tab;
    },
    updateOrdering(){
      //nexttick because need to wait for nexttick from initial virtual preview paint
      this.$nextTick(()=>{
        var blocks = this.iframeDom.document.querySelectorAll('body > [class^="block-"]')
        var blocksLength = blocks.length;
        for (var i=0;i<blocksLength;i++){
          if(!blocks[i].className) continue;
          var match  = blocks[i].className.match(/block-([^ ]+)/);
          if(!match) continue;
          var uid = match.pop();
          var block = this.blocks.find((item)=> item.uid==uid)
          if(!block) continue;
          block.order = i+1;
        }
        this.edited =true;
      });

    }
  },
  mounted(){

    document.addEventListener('click',e => {
      this.pageDropdownOpened = false;
      this.blockDropdownOpened = false;
      this.publishDropdownOpened = false;
    });

    this.getComponents();
    this.getPage();
    this.getPageBlocks();

    document.querySelector('iframe.preview').onload = () => {
      this.iframeDom = document.querySelector('iframe.preview').contentWindow;
      this.loadPreview();
    }

    window.frameBus = {
      handler:null,
      mouseUpIframe:(position)=>{
        this.insertComponent(frameBus.handler,position);
        frameBus.handler = null
      },
      updateOrdering:()=>{
        this.updateOrdering();
      },
      selectBlock:(uid)=>{
        var block = this.blocks.find((item) => item.uid == uid);
        if(block) this.editComponent(block);
      }
    }

  }

}



</script>
